import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, radius, font } from '~styles/theme.stylex';
const DESKTOP = '@media (min-width: 60rem)';
const base = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  backgroundColor: colors.primary,
  color: colors.onPrimary,
  borderStyle: 'none',
  cursor: 'pointer',
  fontFamily: font.family,
  fontSize: '1.0625rem',
  fontWeight: font.semibold,
  paddingBlock: '0.875rem',
  paddingInline: '1.5rem',
  boxShadow: '0 6px 18px rgba(255, 111, 97, 0.45)'
} as const;
export const styles = {
  fab: {
    display: "x3nfvp2 x1tgbc4z",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    cursor: "x1ypdohk",
    fontFamily: "x1qh5nd4",
    fontSize: "x1lkfr7t",
    fontWeight: "xlr2uoh",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    boxShadow: "x129li60",
    position: "xixxii4",
    bottom: "x24nu2v",
    right: "x1sbfeta",
    insetInlineStart: null,
    insetInlineEnd: null,
    zIndex: "x1n327nk",
    $$css: true
  },
  inline: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    cursor: "x1ypdohk",
    fontFamily: "x1qh5nd4",
    fontSize: "x1lkfr7t",
    fontWeight: "xlr2uoh",
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    boxShadow: "x129li60",
    width: "xh8yej3",
    $$css: true
  },
  hideMobile: {
    display: "x1s85apg x1hyortf",
    $$css: true
  },
  md: {
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  lg: {
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  }
};